import React from 'react';
import { useWallet } from '../context/WalletContext';

const NodeTierCard = ({ tier, isSelected, onSelect }) => {
  const { wallet, openWalletModal } = useWallet();
  
  const handleTierSelect = () => {
    if (wallet.connected) {
      // Pass the tier's staking requirement value to the onSelect handler
      const stakingRequirement = tier.stakingRequirement;
      const afiValue = getNumericStakingRequirement(stakingRequirement);
      onSelect(tier.id, afiValue);
    } else {
      // If wallet is not connected, open the wallet modal instead
      openWalletModal();
    }
  };
  
  // Function to extract numeric value from staking requirement string
  const getNumericStakingRequirement = (stakingReq) => {
    if (!stakingReq) return 0;
    
    // Extract digits and remove commas
    const numericPart = stakingReq.toString().replace(/,/g, '').match(/\d+/);
    return numericPart ? parseInt(numericPart[0]) : 0;
  };

  return (
    <div className={`node-tier-card ${isSelected ? 'selected' : ''} ${tier.id}-tier`}>
      <div className="tier-header">
        <div className="tier-level">Level {tier.level}</div>
        <h3 className="tier-name">{tier.name}</h3>
      </div>
      
      <div className="tier-requirements">
        <div className="requirement-item">
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M12 2L2 7L12 12L22 7L12 2Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            <path d="M2 17L12 22L22 17" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            <path d="M2 12L12 17L22 12" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
          <span>
            <strong>Staking:</strong> {tier.stakingRequirement}
          </span>
        </div>
        <div className="requirement-item">
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="12" cy="12" r="9" stroke="currentColor" strokeWidth="2"/>
            <path d="M12 7V12L15 15" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
          </svg>
          <span>
            <strong>Lock Period:</strong> {tier.lockPeriod}
          </span>
        </div>
        <div className="requirement-item">
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M19 4H5C3.89543 4 3 4.89543 3 6V18C3 19.1046 3.89543 20 5 20H19C20.1046 20 21 19.1046 21 18V6C21 4.89543 20.1046 4 19 4Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            <path d="M16 2V6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            <path d="M8 2V6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            <path d="M3 10H21" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
          <span>
            <strong>Max Devices:</strong> {tier.maxDevices}
          </span>
        </div>
      </div>
      
      <div className="tier-benefits">
        <h4>Benefits</h4>
        <ul>
          <li>{tier.miningRewards} of mining rewards from bound devices</li>
          <li>{tier.salesCommission} commission on device sales</li>
          <li>{tier.superiorRewards} rewards when acting as superior node</li>
          {tier.level >= 2 && <li>Voting weight: {tier.votingWeight}</li>}
          {tier.level === 4 && <li>Receives share of registration fee reward pool</li>}
        </ul>
      </div>
      
      <div className="tier-responsibilities">
        <h4>Responsibilities</h4>
        <ul>
          {tier.responsibilities.map((resp, index) => (
            <li key={index}>{resp}</li>
          ))}
        </ul>
      </div>
      
      <div className="tier-cta">
        <button 
          className={`tier-select-btn ${isSelected ? 'selected' : ''}`} 
          onClick={handleTierSelect}
        >
          {isSelected ? 'Selected' : wallet.connected ? 'Choose This Tier' : 'Connect Wallet to Select'}
        </button>
      </div>
    </div>
  );
};

export default NodeTierCard;
